<script setup lang="ts">
import type { KanbanTutor } from '../model/interfaces'

import { useListsStore } from '@shared/model'

import { useTutorKanbanStage } from '../model/tutor-kanban-stage.hook'
import TutorKanbanCard from './tutor-kanban-card/components/TutorKanbanCard.vue'

defineOptions({
  name: 'TutorKanbanStageBody',
})

defineProps<{
  tutors: KanbanTutor[]
}>()

const listsStore = useListsStore()

const {
  isExpired,
  isUpcoming,
  getAgentName,
  handleCardClick,
} = useTutorKanbanStage()
</script>

<template>
  <div class="tkb-stage-body">
    <TutorKanbanCard
      v-for="tutor in tutors"
      :key="tutor.id"
      :name="tutor.full_name"
      :tutor-id="tutor.id"
      :paid-label="tutor.paid_label"
      :agent-name="getAgentName(tutor)"
      :upcoming="isUpcoming(tutor.stage_deadline)"
      :expired="isExpired(tutor.stage_deadline)"
      :priority="tutor.kanban_priority"
      :deadline="tutor.stage_deadline"
      :kanban-priority="listsStore.getLists?.kanban_priority || {}"
      @click="handleCardClick"
    />
  </div>
</template>

<style scoped lang="scss" src="./TutorKanbanStageBody.scss" />
